<div id="{{'cart-case-row-'+  caseRowIndex + '-case-pleadings-issues-container'}}"
    class="table-responsive" *ngIf="gridType==='table' && pleadingTableDataList"
    appAnimateOpen [isOpen]="(rowBeingShown && !rowToBeHidden)" [maxDisplayRows]="maxDisplayRows">
  <table id="{{'cart-case-row-'+  caseRowIndex + '-case-pleadings-issues-table'}}" 
         class="table table-fixedheader table-hover table-condensed table-nowrap">
    <thead id="{{'cart-case-row-'+  caseRowIndex + '-pleadings-issues-table-header'}}">
      <tr>
          <th width="18%">Clocked in on 
            <span popover="This date is the date the document initiating the case was clocked (stamped) in the clerk’s office." popoverTitle="Clocked in on" 
            placement="top" (click)="$event.stopPropagation()" title="">
            <i class="fa fa-info-circle"></i></span></th>
          <th width="27%">Pleading 
            <span popover="Indicates what type of action was filed. For example, Complaint, Motion, Amended Pleading, Confession of Judgment, Consent Order." popoverTitle="Pleading" 
            placement="top" (click)="$event.stopPropagation()" title="">
            <i class="fa fa-info-circle"></i></span></th>
          <th width="55%">Issue 
            <span popover="Issues are specific claims for relief sought by the filing party. For example, Divorce, Money Owed, Default Judgment." popoverTitle="Issue" 
            placement="top" (click)="$event.stopPropagation()" title="">
            <i class="fa fa-info-circle"></i></span></th>
        </tr>
    </thead>
    <tbody id="{{'cart-case-row-'+  caseRowIndex + '-case-pleadings-issues-table-tbody'}}" 
           [class.default-bgcolor]="!bgHighlighted"
           [class.highlighted-bgcolor]="true"
           [class.scroll-overflow-y]="scrollbarShouldBeShown()">
      <tr  id="{{'cart-case-row-'+  caseRowIndex + '-case-pleadings-issues-row-' + k +'-table-tr'}}" 
           *ngFor="let pleadingItem of pleadingTableDataList; let k = index">
        <td id="{{'cart-case-row-'+  caseRowIndex + '-case-pleadings-issues-row-' + k + '-pleading-clock-on' }}"
            width="18%">
           <span title="{{pleadingItem.pleadingClockDate | date:'MM/dd/yyyy'}}">{{pleadingItem.pleadingClockDate | date:'MM/dd/yyyy'}}</span></td>
        <td id="{{'cart-case-row-'+  caseRowIndex + '-case-pleadings-issues-row-' + k + '-pleading' }}"
             width="27%">
           <span title="{{pleadingItem.pleadingType}}">{{pleadingItem.pleadingType}}</span></td>
        <td id="{{'cart-case-row-'+  caseRowIndex + '-case-pleadings-issues-row-' + k + '-issue' }}"
             width="55%">
           <span title="{{pleadingItem.pleadingIssueType}}">{{pleadingItem.pleadingIssueType}}</span></td>
       </tr>      
       <tr *ngIf="(pleadingTableDataList.length ===0)">
         <td width="100%" colspan="3"><span>No pleadings and issues.</span></td> 
       </tr> 
    </tbody>
  </table>
</div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/cart/cart-pleads-grid/cart-pleads-grid.component.html